export class TemplateSingleLineInspectionInput {
    description = '';
    constructor(singleLineInspection) {
        if (singleLineInspection) {
            this.description = singleLineInspection.description;
        }
    }
}
